// extracted by mini-css-extract-plugin
module.exports = {"page":"VXxdNlP4Z04ubIm6ipdaQw==","modal":"y5kNbxHGJloM-OD31jrXWQ=="};